'use client';
import styles from './icon.module.css';

import React, { HTMLAttributes, ReactElement } from 'react';

import { Tooltip, TooltipProps } from '@heroui/tooltip';

import * as Icons from './Icons';
export type IconName = keyof typeof Icons;

export type IconProps = {
  color?: string;
  name: IconName;
  size: string;
  tooltip?: string;
  tooltipProps?: TooltipProps;
} & HTMLAttributes<HTMLElement>;

function Icon({
  color = 'currentColor',
  name,
  size,
  tooltip,
  tooltipProps,
  ...props
}: IconProps): ReactElement {
  const IconSVG = Icons[name] as React.ComponentType<{
    height: string;
    name: string;
    width: string;
  }>;

  if (!IconSVG) return <></>;
  const ParentComponent = (tProps: TooltipProps) =>
    tooltip ? (
      <Tooltip content={tooltip} {...tProps} />
    ) : (
      <>{tProps.children}</>
    );

  return (
    <ParentComponent {...tooltipProps}>
      <i
        className={`${props.className ?? ''} ${styles.icon} `}
        style={{
          color: color,
          ...props.style,
        }}
      >
        <IconSVG height={size} name={name} width={size} />
      </i>
    </ParentComponent>
  );
}
export default Icon;
